import { forwardRef, LegacyRef } from 'react'

import { ChevronDownIcon } from '@ui/components/icons'
import { DatableDataType } from '@ui/interfaces'
import clsx from 'clsx'

interface DropdownProps {
  dataSource: DatableDataType
  setDataSource: (dataSource: DatableDataType) => void
  dataSourceDropdownOpen: boolean
  setDataSourceDropdownOpen: (open: boolean) => void
}

export const DataSourceDropdown = forwardRef<HTMLDivElement, DropdownProps>(
  ({ dataSource, setDataSource, dataSourceDropdownOpen, setDataSourceDropdownOpen }, ref) => {
    return (
      <div className="relative flex w-full flex-row items-center justify-end" ref={ref}>
        <div
          className={clsx(
            'group flex w-full max-w-fit cursor-pointer flex-row items-center justify-center rounded-md border border-gray-200 bg-gray-200 p-2',
            'space-x-1 transition-all duration-300 hover:text-white',
            {
              'hover:bg-logsColor': dataSource === 'logs',
              'hover:bg-spansColor': dataSource === 'spans',
            }
          )}
          onClick={() => setDataSourceDropdownOpen(!dataSourceDropdownOpen)}>
          <div
            className={clsx('size-3 rounded-full', {
              'bg-logsColor group-hover:bg-[#7C94F0]': dataSource === 'logs',
              'bg-spansColor group-hover:bg-[#6ECCA6]': dataSource === 'spans',
            })}
          />
          <p className="text-sm font-medium">{dataSource.slice(0, 1).toUpperCase() + dataSource.slice(1)}</p>
          <ChevronDownIcon
            className={clsx('size-4 stroke-gray-900 transition-all duration-300 group-hover:stroke-white', {
              'rotate-180': dataSourceDropdownOpen,
            })}
          />
        </div>
        {dataSourceDropdownOpen && (
          <div
            ref={ref as LegacyRef<HTMLDivElement>}
            className="absolute right-0 top-10 z-40 flex w-full flex-col space-y-1 rounded-md border border-gray-200 bg-white p-1">
            <div
              className="flex cursor-pointer flex-row items-center justify-center rounded-md bg-logsColor px-2 py-1 text-white transition-all duration-300 hover:opacity-80"
              onClick={() => {
                setDataSource('logs')
                setDataSourceDropdownOpen(false)
              }}>
              <p className="text-sm font-medium">Logs</p>
            </div>
            <div
              className="flex cursor-pointer flex-row items-center justify-center rounded-md bg-spansColor px-2 py-1 text-white transition-all duration-300 hover:opacity-80"
              onClick={() => {
                setDataSource('spans')
                setDataSourceDropdownOpen(false)
              }}>
              <p className="text-sm font-medium">Spans</p>
            </div>
          </div>
        )}
      </div>
    )
  }
)
